import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";

const AdminLoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await axios.post("https://api.lidodavittorio.it/api/admin/login", { username, password });
      localStorage.setItem("isAdmin", "true"); // ✅ Set flag
      navigate("/admin-panel");
    } catch (err) {
      setError("Credenziali non valide");
    }
  };
  
  return (
    <div className="bg-white min-h-screen text-black flex flex-col">
      <NavbarWhite />
      <div className="pt-32 px-4 text-center flex-1 max-w-md mx-auto">
        <h1 className="text-3xl font-[chivo] text-[#009FB7] mb-6">Accesso Admin</h1>
        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="text"
            placeholder="Username"
            className="w-full border px-4 py-2 rounded-md"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            className="w-full border px-4 py-2 rounded-md"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && <p className="text-red-600">{error}</p>}
          <button className="w-full bg-[#009FB7] text-white py-2 rounded-md">Accedi</button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default AdminLoginPage;
